import { defaultBrandSettings, getBrandFromLocalStorage, isClient } from '@systemeio/util';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useMetadataFromServer } from 'shared/hooks/use-metadata-from-server';
import useUser from 'shared/hooks/use-user';
import { useChristmas } from 'shared/layout/components/snow/use-christmas';
import { getDefaultDashboardUrl } from 'shared/utils/get-default-dashboard-url';
import { isSIO } from 'shared/utils/is-sio';
const SioButton = () => {
  const router = useRouter();
  const {
    user,
    isDisabled
  } = useUser();
  const {
    data: metaDataFromServer
  } = useMetadataFromServer();
  const christmasFeatureIsOn = useChristmas();
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  const logoLoader = <div className="bg-text-secondary h-[35px] min-h-[35px] w-[35px] min-w-[35px] animate-pulse rounded-full"></div>;
  const getLogoImage = (src: string = christmasFeatureIsOn ? 'https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-christmas.png' : defaultBrandSettings.logo?.path, alt: string = defaultBrandSettings.name) => {
    return <img className="h-[35px] min-h-[35px] w-[35px] min-w-[35px] object-cover" src={src} alt={alt} />;
  };
  const getWlLogo = () => {
    if (isClient() && hydrated) {
      const brand = getBrandFromLocalStorage();
      if (brand) {
        return getLogoImage(brand.logo?.path, brand.name);
      }
    }
  };
  const getSioLogo = () => {
    if (isSIO(metaDataFromServer?.hostOnServer)) {
      return getLogoImage();
    }
  };
  const getLogo = () => {
    return getSioLogo() ?? getWlLogo() ?? logoLoader;
  };
  return user && !isDisabled ? <button className={'ring-background-secondary rounded-full ring-offset-0 focus-visible:ring-2'} onClick={() => router.push(getDefaultDashboardUrl(user))}>
      <LinkWithoutPrefetch className={'tab focus:outline-hidden'} tabIndex={-1} href={getDefaultDashboardUrl(user)}>
        {getLogo()}
      </LinkWithoutPrefetch>
    </button> : getLogo();
};
export default SioButton;